import { MemberDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';
import { CareAppListActionFactory } from '../action-factory';

class ConversationsActions extends CareAppListActionFactory<void> {
  constructor() {
    super(`Conversations`);
  }

  updateUnreadConversationCount = createAction(
    `[${this.type}][Update] unread count`,
    props<{ count: number }>()
  );

  requestConversationMembers = createAction(`[${this.type}][Request] Members`);

  responseSuccessConversationMembers = createAction(
    `[${this.type}][Response][Success] Members`,
    props<{ members: MemberDto[] }>()
  );

  responseFailConversationMembers = createAction(
    `[${this.type}][Response][Fail] Members`,
    props<{ error: any }>()
  );

  requestStartConversation = createAction(
    `[${this.type}][Request] Start Conversation`,
    props<{ memberIds: string[] }>()
  );

  responseSuccessStartConversation = createAction(
    `[${this.type}][Response][Success] Start Conversation`,
    props<{ cid: string }>()
  );

  responseFailStartConversation = createAction(
    `[${this.type}][Response][Fail] Start Conversation`,
    props<{ error: any }>()
  );

  requestSelectConversation = createAction(
    `[${this.type}][Request] Select Conversation`,
    props<{ cid: string }>()
  );

  responseSuccessSelectConversation = createAction(
    `[${this.type}][Response][Success] Select Conversation`,
    props<{ cid: string }>()
  );

  responseFailSelectConversation = createAction(
    `[${this.type}][Response][Fail] Select Conversation`,
    props<{ error: any }>()
  );

  requestDeselectConversation = createAction(`[${this.type}][Request] Deselect Conversation`);

  responseSuccessDeselectConversation = createAction(
    `[${this.type}][Response][Success] Deselect Conversation`
  );

  responseFailDeselectConversation = createAction(
    `[${this.type}][Response][Fail] Deselect Conversation`,
    props<{ error: any }>()
  );

  requestDisconnectConversations = createAction(`[${this.type}][Request] Disconnect Conversations`);

  responseSuccessDisconnectConversations = createAction(
    `[${this.type}][Response][Success] Disconnect Conversations`
  );

  responseFailDisconnectConversation = createAction(
    `[${this.type}][Response][Fail] Disconnect Conversations`,
    props<{ error: any }>()
  );

  requestCreateConversationDialog = createAction(
    `[${this.type}][Request] Show Create Conversation dialog`
  );

  requestAddChannelModerators = createAction(
    `[${this.type}][Request] Add Moderators to channel`,
    props<{ ids: string[]; channelId: string }>()
  );

  responseSuccessAddChannelModerators = createAction(
    `[${this.type}][Response][Success] Add Moderators to channel`,
    props<{ ids: string[]; channelId: string }>()
  );

  responseFailAddChannelModerators = createAction(
    `[${this.type}][Response][Fail] Add Moderators to channel`,
    props<{ error: any }>()
  );

  requestDemoteChannelModerator = createAction(
    `[${this.type}][Request] Demote channel moderator`,
    props<{ moderatorId: string; channelId: string }>()
  );

  responseSuccessDemoteChannelModerator = createAction(
    `[${this.type}][Response][Success] Demote channel moderator`,
    props<{ moderatorId: string; channelId: string }>()
  );

  responseFailDemoteChannelModerator = createAction(
    `[${this.type}][Response][Fail] Demote channel moderator`,
    props<{ error: any }>()
  );

  requestAddToChannel = createAction(
    `[${this.type}][Request] Add members to channel`,
    props<{ memberIds: string[]; channelId: string }>()
  );

  responseSuccessAddToChannel = createAction(
    `[${this.type}][Response][Success] Add members to channel`,
    props<{ memberIds: string[]; channelId: string }>()
  );

  responseFailAddToChannel = createAction(
    `[${this.type}][Response][Fail] Add members to channel`,
    props<{ error: any }>()
  );
}

export const Conversations = new ConversationsActions();
